
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, Link, useLocation, useNavigationType } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";
import Loader from "../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import SessionPopup from "./SessionPopup"
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import SideMenu from "./student/SideMenu";

import { ToastContainer } from "react-toastify";

import { toast } from "react-toastify";


let { lambda, appname } = window.app

// list position is saved when opening view/edit so coming back returns to the same page
const LIST_POSITION_KEY = "biopsyTypeListPosition";
const DEFAULT_POSITION = { page: 1, perPage: 15, search: "" };
const getSavedListPosition = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(LIST_POSITION_KEY));
        return saved?.page && saved?.perPage ? { ...DEFAULT_POSITION, ...saved } : null;
    } catch {
        return null;
    }
};

const ManageTest = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const navigationType = useNavigationType(); // "POP" = browser back/forward
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);
    const [usersearch, setUserSearch] = useState("");
    // from view/edit (Back button or browser back): restore the saved page; from any other menu: page 1
    const [initialPosition] = useState(() => ((state?.restoreListPage || navigationType === "POP") && getSavedListPosition()) || DEFAULT_POSITION);
    const [page, setPage] = useState(initialPosition.page);
    const [perPage, setPerPage] = useState(initialPosition.perPage);
    const [totalRows, setTotalRows] = useState(0);
    // true when the API paged the result; false when it sent every row (table then pages client-side)
    const [serverPaging, setServerPaging] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
    const requestIdRef = useRef(0);


    // const [isLoading, setIsLoading] = useState(false); 
    const { isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, currentPage, setcurrentPage, data, setData, route, setRoute, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${perPage}_${data?.length}`;
    const columns = [

        {
            name: 'Name',
            selector: row => row?.name ?? "",
            sortable: true,
        },
        {
            name: 'Fee',
            selector: row => row?.fee ?? "",
            sortable: true,
        },
        {
            name:

                //  <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>
                'Actions'
            ,
            cell: (props) =>
                //   {

                <div className="d-flex">

                    <a onClick={(e) => handleViewUser(e, props.lookupcode)}
                        className='text-success action-button'><i
                            className="mdi mdi-eye font-size-18"></i>  </a>

                    <a onClick={(e) => handleEditUser(e, props.lookupcode)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}
                    ><i
                        className="mdi mdi-pencil font-size-18"></i> </a>

                    <a onClick={(e) => handleDeleteUser(e, props.lookupcode)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-delete font-size-18"
                        ></i> </a>

                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        GetTimeActivity()
        setPage(newPage);
        if (serverPaging) {
            fetchBiopsyTypes({ page: newPage, search: activeSearch, showLoader: false });
        }
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        GetTimeActivity()
        setPerPage(newPerPage);
        setPage(1);
        if (serverPaging) {
            fetchBiopsyTypes({ page: 1, perPage: newPerPage, search: activeSearch, showLoader: false });
        }
    };


    useEffect(() => {
        setRoute("user")
        // setActiveMenuId(200003)
        setData([])
        // userActivity();
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };

    }


    useEffect(() => {
        setUserSearch(initialPosition.search);
        fetchBiopsyTypes({ page: initialPosition.page, perPage: initialPosition.perPage, search: initialPosition.search });
    }, []);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    // single fetch for the biopsy types list and search
    const fetchBiopsyTypes = ({ page = 1, perPage: size = perPage, search = "", showLoader = true }) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        axios({
            method: 'GET',
            url: lambda + '/lookupInfo?appname=' + appname + '&type=Biopsy' + (search ? "&search=" + encodeURIComponent(search) : "") + "&paginate=true&pageNumber=" + page + "&pageSize=" + size,
        })
            .then(function (response) {
                // a newer request went out while this one was in flight - drop this response
                if (requestId !== requestIdRef.current) return;

                if (response?.data?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setTableLoading(false)
                    setShowSessionPopupup(true)
                } else {
                    const result = response?.data?.result
                    // paged response is { data, totalCount }; a plain array means the API sent every row
                    const backendPaged = !Array.isArray(result)
                    const rows = (backendPaged ? result?.data : result) ?? []

                    // page is past the end (e.g. last row on the page was deleted) - step back one page
                    if (backendPaged && rows.length === 0 && page > 1) {
                        setPage(page - 1)
                        fetchBiopsyTypes({ page: page - 1, perPage: size, search, showLoader })
                        return
                    }

                    if (!search) setUser(rows);
                    setData(rows);
                    global.exportExcelData = rows
                    setServerPaging(backendPaged);
                    setTotalRows(backendPaged ? (result?.totalCount ?? rows.length) : rows.length);
                    setActiveSearch(search);

                    setIsLoading(false);
                    setTableLoading(false);
                }
            }).catch((err) => {
                if (requestId !== requestIdRef.current) return;
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
                setTableLoading(false);
            });
    }

    const saveListPosition = () => {
        localStorage.setItem(LIST_POSITION_KEY, JSON.stringify({ page, perPage, search: activeSearch }));
    };


    const handleSearch = (e, flagggg) => {
        const inputQuery = usersearch;

        // ✅ Empty / whitespace-only validation
        if (inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setPage(1);
        fetchBiopsyTypes({ page: 1, search: inputQuery });
    };


    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            handleSearch();
        }
    };
    const handleAddUser = (e) => {
        localStorage.removeItem(LIST_POSITION_KEY); // after adding, the list opens on page 1
        navigate("/biopsy/types/new");
    }

    const handleEditUser = (e, paramuserid) => {
        saveListPosition();
        navigate("/biopsy/types/" + paramuserid + "/edit");
    }

    const handleDeleteUser = (e, paramuserid) => {
        setDeleteUserId(paramuserid)
        setDeleteShow(true)
    }

    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

    const onDeletePopupClose = (e) => {
        setDeleteSuccess(false)
        setDeleteUserId(null)
        fetchBiopsyTypes({ page, search: activeSearch, showLoader: false })
    }

    const handleDelete = async (e) => {
        setDeleteShow(false)
        try {
            await tmdbApi.biopsyDelete(deleteUserId);

            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
    }


    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()
        saveListPosition();
        navigate("/biopsy/types/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        setPage(1);
        fetchBiopsyTypes({ page: 1 });
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No biopsy types were found</p>
                </div> </div>
        )
    }
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.name ?? "",
            "USER TYPE": each?.userType ?? "",
            "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "STATUS": each?.status ?? "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        console.log('data22222--->', data)
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                {/* Start right Content here  */}

                <div className="main-content user-management biopsy-types" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Biopsy Types</h4>
                                        </div>

                                        <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser}
                                                disabled={isRestricted}
                                                id="add-user-btn">
                                                ADD
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> :
                                                <>
                                                    <div className="row mb-2" id="table-header-row">
                                                        <div className="col-sm-4 button-block" id="button-block">
                                                            <div className="dataTables_length" id="datatable-length">

                                                                {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                            </div>
                                                        </div>
                                                        <div className="col-sm-8">
                                                            <div className="search-box mb-2 d-inline-block" id="search-box">
                                                                <div className="position-relative">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={usersearch}
                                                                        onChange={(e) => handleChange(e)}
                                                                        placeholder="Search by Name"
                                                                        onKeyPress={handleKeypress}
                                                                        id="search-input"
                                                                    />
                                                                    <button
                                                                        type="button"  // prevents form submission
                                                                        className="fill_btn"
                                                                        onClick={(e) => handleSearch(e, "normalsearch")}
                                                                        id="search-btn"
                                                                    >
                                                                        <span className="material-icons search-icon">search</span>
                                                                    </button>

                                                                </div>
                                                                <div className="dataTables_length" id="datatable-length-reset">
                                                                    <button
                                                                        className="fill_btn"
                                                                        onClick={clearSearch}
                                                                        id="reset-btn">
                                                                        <span className="material-icons-outlined">sync</span>Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="text-sm-end" id="text-end"></div>
                                                        </div>
                                                    </div>

                                                    <DataTable
                                                        key={keyForRerender}
                                                        columns={columns}
                                                        keyField='_id'
                                                        data={data}
                                                        direction="auto"
                                                        highlightOnHover
                                                        fixedHeaderScrollHeight="300px"
                                                        pagination
                                                        paginationServer={serverPaging}
                                                        responsive
                                                        persistTableHead
                                                        striped
                                                        subHeaderAlign="right"
                                                        defaultSortField="name"
                                                        noDataComponent={customNoRecords()}
                                                        paginationTotalRows={totalRows}
                                                        onChangeRowsPerPage={handlePerRowsChange}
                                                        onChangePage={handlePageChange}
                                                        paginationPerPage={perPage}
                                                        paginationDefaultPage={page}
                                                        paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                        sortFunction={customSort}
                                                        paginationComponentOptions={{
                                                            rowsPerPageText: 'Per page:',
                                                            rangeSeparatorText: 'of',
                                                            noRowsPerPage: false,
                                                            selectAllRowsItem: false,
                                                            selectAllRowsItemText: 'All',
                                                        }}
                                                        progressPending={tableLoading}
                                                        progressComponent={<TableLoader />}
                                                        id="data-table"
                                                    />
                                                </>}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert>
                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />


                    <Footer id="footer" />
                </div>




            </div>
        </>
    );
};

export default ManageTest;